module.exports = ".button-spaced{\n  margin: 1em;\n}\n\n#google-sheet-progress-bar{\n  width: 30%;\n}\n"